import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext(null);
export const useTheme = () => useContext(ThemeCtx);

// Bump this whenever we want to force everyone back to the current default.
const THEME_VERSION = "3-light-default";

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    // One-time migration: if the user's stored theme was set on an older
    // theme-version, reset to "light". Any theme change AFTER this reset is
    // recorded fresh under the current version and will be respected.
    if (typeof window !== "undefined") {
      const storedVersion = localStorage.getItem("tnc_theme_version");
      if (storedVersion !== THEME_VERSION) {
        localStorage.setItem("tnc_theme", "light");
        localStorage.setItem("tnc_theme_version", THEME_VERSION);
        return "light";
      }
    }
    const t = typeof window !== "undefined" ? localStorage.getItem("tnc_theme") : null;
    return t === "dark" ? "dark" : "light";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("tnc_theme", theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return <ThemeCtx.Provider value={{ theme, toggle }}>{children}</ThemeCtx.Provider>;
}
